import React from "react";
import "./styles.css";
import "../home-category-section/styles.css";
import { IoCallOutline, IoPersonOutline } from "react-icons/io5";

export const EmergencyContactsSection = ({ contacts }) => {
  const validContacts = Array.isArray(contacts)
    ? contacts.filter((contact) => contact?.name || contact?.phone)
    : [];

  if (validContacts.length === 0) {
    return null;
  }

  return (
    <div className="itemContainer">
      <div className="itemHeader">
        <div className="iconContainer">
          <div
            className="iconInnerContainer"
            style={{ backgroundColor: "#FCE3E1" }}
          >
            <IoPersonOutline size={24} color="#D1483D" />
          </div>
        </div>
        <div className="titleContainer">
          <span className="mainTitleStyling">Emergency Contacts</span>
          <span className="countValueStyling">
            {`${validContacts.length} Contact${
              validContacts.length > 1 ? "s" : ""
            }`}
          </span>
        </div>
      </div>

      <div
        style={{
          padding: "20px",
          borderBottom: "2px solid",
          borderLeft: "2px solid",
          borderRight: "2px solid",
          borderColor: "#EFF3FC",
          borderBottomLeftRadius: 15,
          borderBottomRightRadius: 15,
        }}
      >
        {validContacts.map((contact, index) => (
          <div className="emergencyContactRow" key={index}>
            <div className="emergencyContactDetails">
              <span className="emergencyContactName">
                {contact?.name || "Unnamed contact"}
              </span>
              {contact?.relationship && (
                <span className="emergencyContactRelation">
                  {contact.relationship}
                </span>
              )}
            </div>
            {contact?.phone && (
              <a
                className="emergencyContactPhone"
                href={`tel:${contact.phone}`}
              >
                <IoCallOutline size={16} />
                {contact.phone}
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
